import styles from "../ourCars.module.css";
import { CarMakesProps } from "../types";

const CarMakes = ({ makeList, isSmView, viewCarsDivHeight }: CarMakesProps) => {
  const botbMakes = [{ Key: "All Makes", Value: "All Makes", Link: "/prizes/cars" }, ...makeList];

  if (isSmView) {
    return (
      <>
        <h3 className="font-medium filterSubHeaders">MAKES</h3>
        <ul
          style={{
            height: `calc(100% - ${viewCarsDivHeight}px)`,
            overflowY: "auto",
          }}>
          {botbMakes.map((make, index) => (
            <li key={index} className="py-2">
              {make.Link === null ? (
                <span className={styles.inactiveMake}>{make.Key}</span>
              ) : (
                <a className={styles.activeMake} key={index} href={make.Link}>
                  {make.Value}
                </a>
              )}
            </li>
          ))}
        </ul>
      </>
    );
  }
  return (
    <div className="border-2 bg-white p-4">
      <ul className="flex">
        <li>
          <a href="/app/(general-header)/prizes/cars/win-an-aston-martin">
            <img
              src="/assets/images/wac/manufacturer/aston-martin.png"
              alt="Aston Martin"
              className={styles.makeLogos}
              width={150}
              height={100}
            />
          </a>
        </li>
        <li>
          <a href="/app/(general-header)/prizes/cars/win-a-porsche-competitions">
            <img
              src="/assets/images/wac/manufacturer/porsche.png"
              alt="Porsche"
              className={styles.makeLogos}
              width={150}
              height={100}
            />
          </a>
        </li>
        <li>
          <a href="/app/(general-header)/prizes/cars/win-an-audi">
            <img
              src="/assets/images/wac/manufacturer/audi.png"
              alt="Audi"
              className={styles.makeLogos}
              width={150}
              height={100}
            />
          </a>
        </li>
        <li>
          <a href="/app/(general-header)/prizes/cars/win-a-bmw">
            <img
              src="/assets/images/wac/manufacturer/bmw.png"
              alt="BMW"
              className={styles.makeLogos}
              width={150}
              height={100}
            />
          </a>
        </li>
        <li>
          <a href="/app/(general-header)/prizes/cars/win-a-mercedes">
            <img
              src="/assets/images/wac/manufacturer/mercedes.png"
              alt="Mercedes"
              className={styles.makeLogos}
              width={150}
              height={100}
            />
          </a>
        </li>
        <li>
          <a href="/app/(general-header)/prizes/cars/win-a-range-rover">
            <img
              src="/assets/images/wac/manufacturer/range-rover.png"
              alt="Slider Rover"
              className={styles.makeLogos}
              width={150}
              height={100}
            />
          </a>
        </li>
      </ul>
      <div className="grid grid-cols-4 gap-4 mt-4">
        {botbMakes.map((make, index) =>
          make.Link === null ? (
            <span className={styles.inactiveMake} key={index}>
              {make.Key}
            </span>
          ) : (
            <a className={styles.activeMake} key={index} href={make.Link}>
              {make.Value}
            </a>
          )
        )}
      </div>
    </div>
  );
};

export default CarMakes;
